import streaming from '../assets/6 felfunk/1 streaming-small.jpg';
import streaming_small from '../assets/6 felfunk/1 streaming-small.jpg';
import ok from '../assets/6 felfunk/felfunks/velame ok.jpg';
import ok_small from '../assets/6 felfunk/felfunks/velame ok.jpg';
import kutt from '../assets/6 felfunk/4 Sköld kutt 240921 Sköld - Cutt.MP4-00_00_03-2024-09-24-21h59m01s280.png';
import kutt_small from '../assets/6 felfunk/4 Sköld kutt-small.jpg';
import snodd from '../assets/6 felfunk/mina/1 kort snodd-small.jpg';
import snodd_small from '../assets/6 felfunk/mina/1 kort snodd-small.jpg';
import inblasning from '../assets/6 felfunk/mina/4 inblåsningar-small.jpg';
import inblasning_small from '../assets/6 felfunk/mina/4 inblåsningar-small.jpg';
import toggleFire from '../assets/6 felfunk/mina/5 toggle fire-label-small.jpg';
import toggleFire_small from '../assets/6 felfunk/mina/5 toggle fire-label-small.jpg';
import framkant from '../assets/6 felfunk/felfunks/Pilotinho por baixo-small.jpg';
import framkant_small from '../assets/6 felfunk/felfunks/Pilotinho por baixo-small.jpg';
import lineOver from '../assets/6 felfunk/felfunks/line over-small.jpg';
import lineOver_small from '../assets/6 felfunk/felfunks/line over-small.jpg';
import langSnodd from '../assets/6 felfunk/felfunks/3 anormalidades-small.jpg';
import langSnodd_small from '../assets/6 felfunk/felfunks/3 anormalidades-small.jpg';
import trasigaLinor from '../assets/6 felfunk/felfunks/Linhas arrebentadas-small.jpg';
import trasigaLinor_small from '../assets/6 felfunk/felfunks/Linhas arrebentadas-small.jpg';
import trasigFallskarm from '../assets/6 felfunk/felfunks/Rasgado-small.jpg';
import trasigFallskarm_small from '../assets/6 felfunk/felfunks/Rasgado-small.jpg';
import baglock from '../assets/6 felfunk/felfunks/bag lock-small.jpg';
import baglock_small from '../assets/6 felfunk/felfunks/bag lock-small.jpg';
import streamer from '../assets/6 felfunk/1 streaming-small.jpg';
import streamer_small from '../assets/6 felfunk/1 streaming-small.jpg';
import inteHitta from '../assets/6 felfunk/mina/7 hittar inte handtaget-small.jpg';
import inteHitta_small from '../assets/6 felfunk/mina/7 hittar inte handtaget-small.jpg';
import fordrojning from '../assets/6 felfunk/mina/8 fördröjning-small.jpg';
import fordrojning_small from '../assets/6 felfunk/mina/8 fördröjning-small.jpg';
import iplanet from '../assets/6 felfunk/mina/9 i planet-small.jpg';
import iplanet_small from '../assets/6 felfunk/mina/9 i planet-small.jpg';
import biplane from '../assets/6 felfunk/felfunks/biplano-small.jpg';
import biplane_small from '../assets/6 felfunk/felfunks/biplano-small.jpg';
import sideBySide from '../assets/6 felfunk/felfunks/side by side-small.jpg';
import sideBySide_small from '../assets/6 felfunk/felfunks/side by side-small.jpg';
import downplane from '../assets/6 felfunk/downplane-small.jpg';
import downplane_small from '../assets/6 felfunk/downplane-small.jpg';
import kniv from '../assets/6 felfunk/3 kniv-small.jpg';
import kniv_small from '../assets/6 felfunk/3 kniv-small.jpg';
import selprov from '../assets/6 felfunk/2 reservsele-small.jpg';
import selprov_small from '../assets/6 felfunk/2 reservsele-small.jpg';

import { Article, DocsHeader, DocsHeading, DocsIntro, Image, Section, SectionHeader } from '../extra/Components';
import { Question, Questionary } from '../extra/Quiz';

import {
    faSkullCrossbones,
} from "@fortawesome/free-solid-svg-icons";

const felFunkQuiz = [
    Question.order("Reservdragsprocedur", ["Se!", "Ta!", "Se!", "Ta!", "Kutta!", "Dra!", "Svanka!"]),
    Question.order("Hantag i ordning för reservdragsprocedur", ["Ta tag i kutthandtaget", "Ta tag i reservhandtag", "Dra kutthandtaget", "Dra reservhandtaget"], ["Ta tag i pilothandtaget", "Dra pilothandtaget", "Dra RSLen"]),
    Question.oneQ("Vad är beslutshöjden under utbildningen?", "700m", ["600m", "500m", "900m"]),
    Question.oneQ("Vad är beslutshöjd?", "Den höjd man senast drar sin reserv om man inte har en fungerande huvudfallskärm", ["Sista höjden det går att dra reserven utan att dö.", "Där man drar huvudfallskärmen"]),
    Question.qManyA("Välj högfartfelfunktionerna", ["Baglåsning", "Piloten sitter fast", "Streamer"], ["Lång snodd", "Trasig fallskärm", "Pilot över framkant"]),
    Question.qManyA("Välj lågfartfelfunktionerna", ["Slider upphängning", "Trasig fallskärm", "Trassel"], ["Kort snodd", "Piloten sitter fast", "Streamer"]),
    Question.qManyA("Välj driftstörningarna", ["Hög slider", "Toggle fire", "Inblåsning"], ["Line over", "Packlåsning", "Step through"]),
    Question.oneQ("Får jag dubbla fallskärmar i fenomenet Biplane bör jag: ", "Göra så lite som möjligt, svänger bara för att undvika hinder", ["Kutta huvudfallskärmen", "Styr som vanligt på min huvudfallskärm", "Styr som vanligt med bakre bärremmar på främre fallskärmen"]),
    Question.oneQ("Måste jag göra selprov efter uppehåll?", "Ja", ["Nej", "Där man drar huvudfallskärmen"]),
    Question.oneQ("Vad är den lägsta höjden jag kan dra sin reserv?", "Det finns inget lägsta", ["300m", "700 m", "500 m", "1000 m", "100 m"]),
    Question.oneQ("Vad är den lägsta höjden jag kan kutta om jag bara har en fallskärm?", "300m", ["700 m", "500 m", "1000 m", "100 m", "Det finns inget lägsta"]),
];


const felfunkQuizSection = <Section id="felfunk-quiz" name="Quiz">
    <SectionHeader>Quiz, felfunktioner</SectionHeader>
    <Questionary
        questions={felFunkQuiz} />
</Section>;

const Felfunktioner = ({ setSection, setArticle }) => (
    <Article name="Felfunktioner" icon={faSkullCrossbones} id="felfunktioner" setArticle={setArticle} setSection={setSection}>
        {felfunkIntro}
        {felfunkBraFallskärm}
        {felfunkReservdrag}
        {felfunkBeslutshojd}
        {felfunkHogfarLagfart}
        {felfunkKända}
        {felfunkOrsaker}
        {felfunkKniv}
        {felfunkSelprov}
        {felfunkQuizSection}
    </Article >
);


const felfunkIntro = <DocsHeader>
    <DocsHeading note="Updaterad: 2022-07-13">Felfunktioner</DocsHeading>
    <DocsIntro>
        <Image image={streaming} imageSmall={streaming_small} alt="Streaming" />

        <p>Fallskärmar funkar oftast. Väldigt oftast. Närmare 999 av 1000 gånger. För den här 1000e
            gånger är varför vi hoppar med en reservfallskärm. I det här kapitlet tittar vi på vad
            vi kan fixa och vad vi ska göra om vi inte kan fixa det.</p>
    </DocsIntro>
</DocsHeader>;

const felfunkBraFallskärm = <Section id="braskarm" name="Bra fallskärm">
    <SectionHeader>Vad är en bra fallskärm?</SectionHeader>
    <p>Det finns väldigt många saker som kan gå fel med en fallskärm. Här tar vi det baklänges och
        tittar på vad som kännetecknar en fullt fungerande fallskärm. Då slipper man tänka på exakt
        vad som är fel och kan fokusera på om man ska agera.</p>
    <Image image={ok} imageSmall={ok_small} alt="Fungerande fallskärm" />

    <ul>
        <li><strong>Där</strong>, (avsaknad av fallskärm är en felfunktion)</li>
        <li><strong>Hel</strong></li>
        <li><strong>Rektangulär</strong>/symmetrisk</li>
        <li><strong>Linorna löper fritt och är hela</strong>, inget trassel</li>
        <li><strong>Slidern nere</strong></li>
        <li><strong>Flyger rakt</strong>, svänger inte</li>
        <li><b>Går att styra</b>, inte säkert man upptäcker förrän man lossar bromsarna</li>
    </ul>
    <p>Uppfyller en fallskärm alla de här kriterierna så är den bra. Gör den inte det så är den inte
        bra. En fallskärm kan verka bra när den öppnas men sedan inte gå att styra när man lossar
        bromsarna. Då är den inte längre bra.</p>
</Section>;

const felfunkReservdrag = <Section id="reservdrag" name="Reservdragsprocedur">
    <SectionHeader>Reservdrag</SectionHeader>
    <Image image={kutt} imageSmall={kutt_small} alt="Kuttad fallskärm" />

    <p>Hur man bär sig åt när ens fallskärm inte fungerar enligt ovan</p>
    <ul>
        <li><strong>Se</strong>, titta ner och hitta kutt-handtaget</li>
        <li><strong>Ta</strong>, greppa kutt-handtaget</li>
        <li><strong>Se</strong>, titta ner och hitta reserv-handtaget</li>
        <li><strong>Ta</strong>, greppa reserv-handtaget med tummen genom bygeln</li>
        <li><strong>Kutta</strong>, vrid loss kutt-handtaget och dra sedan nedåt till fullt
            utsträckt arm</li>
        <li><strong>Dra</strong>, dra reserv-handtaget nedåt till fullt utsträckt arm</li>
        <li><strong>Svanka</strong>, stabil frifallsställning för att ge reserven </li>
    </ul>
    <p>Det är viktigt att man följer dessa steg i den ordningen. Man ser och känner rätt på
        handtagen. De kan skifta lite i frifall och det är viktigt man hittar och hittar rätt sak.
        Kutt handtag kan vara lite svåra att få loss. Därför använder vi knepet vrid, kardborre
        släpper lättare på det sättet. Kutten ska dras fullständigt innan man drar reserv-handtaget.
        Det gör man för att säkerställa att den gamla fallskärmen är helt losskopplad och man inte
        riskerar att trassla in reserven i den eller ha två fallskärmar samtidigt. När man har
        dragit reservhandtaget så är man i frifall till att den blåst upp sig. Det är sista
        fallskärmen man har och man vill ge den bästa möjliga förutsättningar att öppnas korrekt.
        Det gör man genom att ge sin allra bästa frifallsställning och håller den till reserven är
        ute.
    </p>
    <p>
        På kurs övar man hela det här momentet flera gånger.
    </p>
    <p>Det är tillåtet att släppa handtagen när man är färdig med reservdraget men det är också
        tillåtet att hålla kvar. Håller man kvar sparar man några kronor mot att ersätta de men om
        man behöver använda händerna för att lösa något problem med reserven är det väldigt lite
        pengar att dö för. Är allt lugnt kan man hålla kvar de och sen stoppa in de innanför
        overallen.</p>

</Section>;

const felfunkKända = <Section id="exempel" name="Exempel">
    <SectionHeader>Exempel</SectionHeader>
    <p>Nedan går vi igenom några exempel på olika som kan hända och hur dessa klassificeras. Detta
        är
        ingen uttömmande lista utan tar bara upp några exempel.</p>
    <h3>Driftstörningar</h3>
    <ul>
        <li><strong>Kort snodd</strong>, löses genom att vifta med fötterna för att försöka vrida
            kroppen "cykla"
            <Image image={snodd} imageSmall={snodd_small} alt=" Kort snodd" />

        </li>
        <li><strong>Inblåsning</strong>, cellerna längst ut fyller sig inte med luft. Oftast löser
            det sig själv efter en liten stund. Gör det inte det kan man pumpa bromsarna. Bilden
            för hög slider har även inblåsning</li>
        <li><strong>Hög slider</strong>, slidern kommer inte hela vägen ner. Gör man två stora
            inbromsningar brukar den komma ner.
            <Image image={inblasning} imageSmall={inblasning_small} alt="Inblåsning och hög slider" />

        </li>

        <li><strong>Toggle fire</strong>, ena styrhandtaget lossnar i öppningsförloppet. Fallskärmen
            får ett sväng input och svänger. Lossa andra för att flyga rakt
            <Image image={toggleFire} imageSmall={toggleFire_small} alt="Toggel fire (lossnat styrhandtag)" />

        </li>
        <li><strong>Pilot över framkant</strong>, väldigt ovanligt med moderna kasta ut piloter men
            händer det testar man om fallskärmen uppfyller alla krav för en fungerande fallskärm
            med fokus på går att styra. Beter den sig konstigt eller oförutsägbart är det en
            felfunktion. Flyger den bra så fortsätter man utan några vidare åtgärder.
            <Image image={framkant} imageSmall={framkant_small} alt="Piloten över framkant" />

        </li>
    </ul>
    <h3>Lågfartfelfunktioner</h3>
    <ul>
        <li><strong>Brusten styrlina</strong> uppfyller inte fallskärmen kriteriet "går att styra" så duger den inte till att landa.
            Senare i ens fallskärmskarriär lär man sig att det går att styra en fallskärm med bakre bärremmar men att landa en fallskärm så under sin utbildning är inte att rekommendera.
            Det är avsevärt svårare att landa en fallskärm med bakre bärremmar än styrhandtag så beslut att försöka sig på det får göras mot ens erfarenhet.
        </li>

        <li><strong>Line over</strong>, som titel. En lina är fel upp runt fallskärmen. Man kan
            testa att göra två stora inbromsningar om man har gott om tid och det är nära sidan av
            fallskärmen. Lossnar det inte genomför man reservdragsprocedur.
            <Image image={lineOver} imageSmall={lineOver_small} alt="Line over" />

        </li>
        <li><strong>Trassel</strong>, linorna är trasslade och hindrar slidern från att komma ner
            eller styrlinorna från att styra. I regel inte något annat att göra än att byta
            fallskärm.</li>
        <li><strong>Slider upphängning</strong>, hög slider som inte kommer ner. Ofta i kombination
            med trassel.</li>
        <li><strong>Lång snodd</strong>, alla snoddar man inte kan lösa innan beslutshöjd är långa
            snoddar. Oberoende av hur många varv de är.

            <Image image={langSnodd} imageSmall={langSnodd_small} alt="Lång snodd" />

        </li>
        <li><strong>Step through</strong>, linorna korsar varandra på väg upp till fallskärmen.
            Hindrar sannolikt sliderna från att komma ner och beror troligtvis på någon gått igenom
            linorna med riggen men inte fixat det medan den packades</li>
        <li><strong>Fastnat styrhandtag</strong>, får inte loss styrhandtaget eller styrlinan
            fastnar i öglan. Fallskärmen uppfyller inte kriteriet går att styra.</li>
        <li><strong>Brusten bärlina</strong>, någon eller några linor som inte är styrlinor har gått
            av. Det diskvalificerar fallskärmen oberoende av hur erfaren man är.
            <Image image={trasigaLinor} imageSmall={trasigaLinor_small} alt="Trasiga bärlinor" />

        </li>
        <li><strong>Trasig fallskärm</strong>, självförklarande.
            <Image image={trasigFallskarm} imageSmall={trasigFallskarm_small} alt="Trasig fallskärm" />

        </li>
    </ul>
    <h3>Högfartfelfunktioner</h3>
    <ul>
        <li><strong>Inget händer</strong> efter vi kastat piloten och räknat. Utan att diagnosticera
            mer specifikt är vi i frifall och
            behöver åtgärda.</li>
        <li><strong>Packlåsning</strong> piloten är kastad men den lyckas inte dra loss
            huvudskärmssprinten.</li>
        <li><strong>Baglåsning</strong>, bagen är ute men den öppnar sig inte eller fallskärmen
            kommer inte helt ur den.
            <Image image={baglock} imageSmall={baglock_small} alt="Baglåsning" />

        </li>
        <li><strong>Streamer</strong> fallskärmen kommer ut men blåser inte upp sig och. "Streaming"
            är en del utav utlösningsförloppet som varar i några sekunder. Varar det längre än så så
            är det en högfartfelfunktion.
            <Image image={streamer} imageSmall={streamer_small} alt="Streamer" />

        </li>
        <li><strong>Hittar inte handtaget</strong>, hittar man inte pilothandtaget på två försök
            räknas det som en felfunktion. Det kan bero på att man letar på fel ställe.
            <Image image={inteHitta} imageSmall={inteHitta_small} alt="Hittar inte handtaget" />

        </li>
        <li><strong>Handtaget sitter fast</strong>, får man inte ut piloten när man försöker räknas
            det som en högfartfelfunktion.</li>
        <li><strong>Hästsko</strong>, om piloten kastas ut men fastnar i t.ex. hopparens skor så
            bildas ett upp och ner vänt U från piloten till treringarna via linorna. Att få loss
            piloten och få en fungerande reserv är tidskritiskt.</li>
    </ul>
    <h3>Annat</h3>
    <ul>
        <li><strong>Vakuum/fördröjning</strong>, ovanför en hoppare i frifall är en bubbla utav
            turbulens. Den kallas vakuum. Lösningen är att doppa en axel och släppa frisk luft över
            ryggen till piloten.
            <Image image={fordrojning} imageSmall={fordrojning_small} alt="Fördröjning" />

        </li>
        <li><strong>Vådautlösning</strong>, fallskärmen löser ut utan att hopparen kastade piloten.
            Det kan hända om sprinten lossnar eller man har en slapp pilotficka som och faller på
            ett sätt så piloten blåser ut. I en våda utlösning är risken för intrassling och skador
            på skärmen högre än normalt och man bör kontrollera den efter den kommit ut. Man bör
            också hålla koll på skicket på sin utrustning för att förebygga Vådautlösningar.</li>

        <li><strong>Fastnat i flygplanet</strong>, om någon eller en själv fastnar i någon del av
            flygplanet och blir hängande. Lämpligen hjälper man de ut.</li>

        <li><strong>Vådautlösning i flygplanet</strong>
            <Image image={iplanet} imageSmall={iplanet_small} alt="Hittar inte handtaget" />

            Det kan hända att någon tappar ut sin pilot eller kommer åt sin reserv i flygplanet. Den
            stora faran är att piloten flyger ut genom dörren och hopparen skadar sig när
            fallskärmen drar ut hen. Är en hoppare redan i dörren puttar man ut den. Är den längre
            in i planet fångar man piloten och ropar att dörren ska stängas.
            Detta gör att när man flyger med planet vill man alltid ha dörren öppen nog att en
            hoppare kan kamma ut eller helt stängd så en pilot inte kan komma ut. Det vill säga att
            flyga
            med dörren lite öppnad för att få in luft blir väldigt farligt om en pilotfallskärm
            skulle trilla
            ut. Kommer bagen ut och fallskärmen tar luft kommer hopparen slitas ut genom dörren.
        </li>
    </ul>
    <h3>Dubbla fallskärmar</h3>
    <p>Scenarion där vi har två fallskärmar skiljer sig från övriga felfunktioner i att vi kan vara
        i en stabil situation och trassla ihop det genom att koppla loss huvudfallskärmen.
        Huvudregeln är att inte göra något man inte måste. Hänger man och flyger stabilt så
        fortsätter man så. Man styr minimalt bara för att undvika hinder. Med dubbelt så mycket tyg
        ute kommer man landa ganska mjukt. Man gör sig redo att rulla. Att försöka bromsa
        fallskärmarna inför landning gör ingen nytta.
    </p>
    <p>Dubbla fallskärmar uppstår oftast om en erfaren hoppare flyger en elev AAD för lågt och
        triggar den eller drar sin huvudfallskärm såpass lågt att att i utlösningsförloppet löser
        AADn ut med en till fallskärm. Att starta sin AAD i flygplanet på väg upp skulle också kunna
        få den att lösa ut på högre höjd.</p>
    <ul>
        <li><strong>Biplane</strong>, låt bromsarna sitta kvar på båda skärmar. Styr med bakre
            bärremmar på den främre fallskärmen.
            <Image image={biplane} imageSmall={biplane_small} alt="Biplane" />

        </li>
        <li><strong>Side by side</strong>, låt bromsarna sitta kvar på båda fallskärmar. Styr med
            bakre på den dominanta fallskärmen. Dvs den som är mest uppåt.
            <Image image={sideBySide} imageSmall={sideBySide_small} alt="Side by side" />

        </li>
        <li><strong>Downplane</strong>, är när fallskärmarna går ifrån varandra och vi får fart
            neråt. I och med fallskärmarna är ifrån varandra kan vi koppla loss huvudfallskärmen
            utan att den trasslar in i reserven och flyga den som vanligt därefter.
            <Image image={downplane} imageSmall={downplane_small} alt="Downplane" />

        </li>
    </ul>
</Section>;

const felfunkOrsaker = <Section id="orsaker" name="Orsaker och förebyggande">
    <SectionHeader>Orsaker och förebyggande</SectionHeader>
    <p>Man kan göra allting perfekt men ändå få felfunktioner till slut utav naturen med att kasta
        ut lite nylon i 200 kilometer i timmen. Man kan däremot göra saker bra och sänka
        sannolikheten för felfunktioner eller göra de mildare när de dyker upp. Huvudanledningarna
        som kan orsaka felfunktioner beskrivs nedan.</p>
    <ul>
        <li><strong>Felaktigt eller slarvigt packad utrustning</strong>: Många av felen ovan kan
            förklaras med att fallskärmen inte packades bättre. En skärm som packats osymmetriskt
            kommer ut osymmetriskt och svänger sig gärna till en snodd. Knyter man fast pilotlinan i
            något av misstag kommer den inte kunna dra piloten och man får en packlåsning. Det är
            aldrig för bråttom för att packa sin fallskärm rätt. Som man packar får man öppna.</li>
        <li><strong>Skada utrusning</strong>: Gamla slitna linor har lättare för att gå av. Sjunger
            ens loop på sista versen och man går ihop med någon kan den gå av och man får en
            vådautlösning. Byta slitagedelar i tid och hålla koll är bästa skyddet där.</li>
        <li><strong>Ostabil fallställning</strong>: ligger man och lutar när man drar sin fallskärm
            så får den ett snett input vilket medför att den svänger och gärna snoddar. Ligger man
            och roterar gör man snodden själv. Ligger man på rygg och drar måste alla linor förbi
            vilket kan leda till att man trasslar in sig.</li>
        <li><strong>Störningar i utlösningsförloppet</strong>: Under de första AFF-hoppen ligger
            instruktörerna bredvid och håller i en under draget. Det gör att man ligger stadigt men
            fler personer runt en under drag ger mer turbulens och det är rentav sannolikt att du
            får en snodd under någon av dina AFF-hopp.</li>
        <li><strong>Felaktigt påtagen utrustning</strong>: har man spänt benremmarna olika mycket
            kommer selen sitta snett vilket get ett snett input till fallskärmen vilket än en gång
            kan leda till snodd.</li>
    </ul>
    <p>Det man ska ha med sig är att fallskärmsutrustning är förlåtande inom vissa gränser på hur
        man packar och öppnar den. Att ligga snett medan man drar ökar risken för snodd. Det kan
        göra att sannolikheten att man behöver dra reserven går från 1/10000 till 1/100. Man kommer
        antagligen undan med dumheter några gånger innan det går snett. Man vill hitta alla saker
        man gör som ökar risker och skjustera innan man inser att man sänkt sina odds till 1/10. En
        av de farligaste sakerna man kan göra är ett fel och komma undan med det. Då bygger man ett
        falskt förtroende.</p>
</Section>;

const felfunkKniv = <Section id="kniv" name="Kniv">
    <SectionHeader>Kniv</SectionHeader>
    <Image image={kniv} imageSmall={kniv_small} alt="Kniv" />

    <p>Från utrustningskapitlet känner du igen att vi har en kniv med oss när vi hoppar fallskärm.
        Kniven är till för att få loss saker som sitter fast när vi inte har något annat alternativ.
        Om vi får en line over på huvudfallskärmen har vi alternativet att byta till reserven. Får
        vi en line over på reserven är vår enda möjlighet att skära av linan som går över. Det är
        ett <b>mycket</b> sällsynt scenario och gör man det ska man vara väldigt noggrann med att
        skära av rätt lina.</p>
    <p>Trasslar man in sig i sin huvudskärms linor och de förhindrar en eller förstör när man
        försöker flyga sin reserv gör man bra i att skära loss den.</p>
    <p>Om en treringar är felmonterade och inte går att kutta med kutthandtaget så kan man alltid
        kutta med kniv.</p>
    <p>Skulle någon icke kritisk del av en hoppare sitta fast i flygplanet, t.ex. del av hens
        overall skulle skära loss den vara ett rimligt användande av kniv.</p>
    <p>Kniven är bara till för nödsituationer och ska inte användas för annat än nödsituationer. Den
        ska sitta orörd på riggen till den dag den behövs.</p>
</Section>;


const felfunkBeslutshojd = <Section id="beslutshpjd" name="Beslutshöjd">
    <SectionHeader>Beslutshöjd</SectionHeader>
    <p>Reserver liksom huvudfallskärm tar tid på sig att öppna. Den öppnar snabbare men det finns
        gränser. Den lägsta höjd där man i frifall kan hoppas att hinna få ut en fallskärm är den
        höjd AADn löser ut reserven på. Lägre än så går sannolikheten mot att man bildar en krater
        vid landning. Reservenutlösning efter att piloten frigjorts drivs utav fartvinden. Det gör
        att färdas man i lägre hastighet med en inte fullt fungerande fallskärm kommer det ta
        <b>mer</b> höjd för reserven att lösa ut. Under 300m är det sannolikt mer nyttigt att lösa
        ut reserven utan att koppla loss huvudfallskärmen med principen mer tyg mer broms.
    </p>
    <p>För att undvika ovan avvägningar finns konceptet beslutshöjd. Har man en delvis fungerande
        fallskärm tar man beslut på sin beslutshöjd om att fortsätta med den eller inte och kan då
        genomföra reservdrag i lämplig höjd. Under utbildningen är beslutshöjden
        <strong>700m</strong>. Om man senare i sin fallskärmskarriär sänker sin draghöjd följer en
        sänkt beslutshöjd om man vill ha en chans att korrigera driftstörningar. Den bör inte bli
        lägre än <b>500m</b> för att man säkert ska kunna agera och genomföra ett reservdrag i tid.
    </p>
</Section>

const felfunkSelprov = <Section id="sele" name="Selprov">
    <SectionHeader>Selprov</SectionHeader>
    <Image image={selprov} imageSmall={selprov_small} alt="Selprov" />

    <p>Innan man tillåts hoppa fallskärm eller efter man haft ett långt uppehåll ska man göra ett
        selprov. Man hängs upp i en sele med likadana handtag som en fallskärmsutrustning och
        presenteras med olika scenarion. Man ska agera snabbt och korrekt för att lösa sina problem.
        Man börjar med att kasta piloten och genomför sin kallotdrill. När man göra sin
        kallott kontroll håller instruktören upp en bild på en fallskärm. På kursen kommer man öva
        flera gånger innan man prövas på det.</p>
</Section>;

const felfunkHogfarLagfart = <Section id="agerande" name="Kategorier och agerande">
    <SectionHeader>Kategorier och agerande</SectionHeader>
    <p>När man kommer till slutet av sin kallott kontroll och tittar upp och inte ser en fungerande
        fallskärm finns det två typer av situationer.</p>
    <ul>
        <li><strong>Lågfart</strong>, fallskärmen är åtminstone delvis ute flyger tillräckligt att
            vi har tid att tänka efter. Vi färdas i låg fart.</li>
        <li><strong>Högfart</strong>, fallskärmen är <b>inte</b> ute eller inte tillräckligt ute och
            vi fortsätter färdas i hög fart.</li>
    </ul>
    <p>Utav det ovan ska vi prata om felfunktioner. När vi befinner oss i hög fart kräver det ett
        omedelbart agerande. Vi utför reservdragsprocedur och säger då att vi haft en
        <b>högfartfelfunktion</b>. Motsvarigheten för lågfart är <b>lågfartfelfunktion</b>.
        Skillnaden är
        att i låg fart har vi betänketid och kan åtgärda vissa fel. Kan vi åtgärda det är det
        inte längre en lågfartfelfunktion utan en <b>driftstörning</b>. Har man inte åtgärdat den
        driftstörning man har innan sin beslutshöjd övergår den per definition till att vara en
        felfunktion och ska åtgärdas med reservdragsprocedur. Det finns inget krav på att man måste
        försöka hela vägen till beslutshöjd. Tvärtom desto tidigare man ser att det inte går att
        lösa desto mer tid har man att landa på ett säkert ställe med sin reserv. För att
        sammanfatta:
    </p>
    <ul>
        <li><strong>Driftstörning</strong>, problem med fallskärmen som går att lösa.</li>
        <li><strong>Lågfartfelfunktion</strong>, ett fel med fallskärmen som inte går att lösa eller
            en driftstörning vi inte hinner lösa.</li>
        <li><strong>Högfartfelfunktion</strong>, ett fel vi inte hinner lösa oberoende.</li>
    </ul>
    <p>
        Här ser man att ett av de viktigaste sätten att skilja på en lågfartfelfunktion och en
        driftstörning är att konstant kolla sin höjdmätare. Har man nått sin beslutshöjd så är
        det en felfunktion och man genomför reservdrag.
    </p>
</Section>;


export {
    Felfunktioner, felFunkQuiz, felfunkIntro, felfunkBraFallskärm, felfunkReservdrag, felfunkBeslutshojd, felfunkHogfarLagfart, felfunkSelprov,
    felfunkKända, felfunkOrsaker, felfunkKniv, felfunkQuizSection
};